import styles from './styles.module.css';

/**
 * Bloco "Concorre a" do bilhete: o sorteio promocional da banca (tela
 * /sorteio/criar) em que o bilhete entrou.
 *
 * Nos sorteios de 4 e 5 dígitos o bilhete ganha um número na venda, e é ele que
 * o administrador procura ao lançar o resultado. `numero` chega como texto e com
 * zero à esquerda ("0725") — nunca converter para número, senão vira 725.
 *
 * `numero` é null no sorteio aleatório e no bilhete que não concorre de fato
 * (modalidade ou gerente fora do sorteio). O "Concorre a" em si só olha valor
 * mínimo e data, então pode aparecer sem número.
 */
export default function SorteioPremioBilhete({sorteioPremio}) {
    if (!sorteioPremio) return null;

    const {premio, info, data, numero} = sorteioPremio;

    return (
        <>
            <hr/>
            <span> Concorre a <strong>{premio?.premio}</strong></span>
            <br/>
            {numero && (
                <>
                    <span> Número do sorteio: <strong>{numero}</strong></span>
                    <br/>
                </>
            )}
            {info && (
                <>
                    <span>{info}</span>
                    <br/>
                </>
            )}
            <span> Sorteio dia {data}</span>
            <br/>
            {premio?.icon && (
                <div className={styles.icone}>
                    <i className={`fa ${premio.icon}`} aria-hidden="true"></i>
                </div>
            )}
            <hr/>
        </>
    );
}
